// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.

import React, { useState } from "react";
// import "./connexionError.css";
import { useNavigate } from "react-router-dom";
// import { useQueryClient } from "@tanstack/react-query";

const ConnexionErrorPage: React.FC = () => {
  const [isRetrying, setIsRetrying] = useState(false);
  const navigate = useNavigate();

  // const quertClient = useQueryClient();
  const handleRetry = () => {
    // quertClient.clear();
    setIsRetrying(true);
    setTimeout(() => {
      setIsRetrying(false);
      navigate(-1);
      // window.location.reload();
    }, 2000);
  };
  return (
    <div className="fixed inset-0 z-50 min-h-screen overflow-hidden bg-[#E9EEF6]">
      {/* =====================================================
        BACKGROUND
    ====================================================== */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#E8EEF8] via-[#DDE7F3] to-[#CFDDF0]" />

        {/* Soft glows */}
        <div className="absolute -left-40 -top-48 h-[500px] w-[500px] rounded-full bg-blue-300/20 blur-3xl" />
        <div className="absolute -bottom-52 right-[5%] h-[500px] w-[500px] rounded-full bg-indigo-300/20 blur-3xl" />

        {/* Decorative circle */}
        <div className="absolute -right-28 -top-32 h-[420px] w-[420px] rounded-full border-[70px] border-white/15" />

        {/* Dot pattern */}
        <div
          className="absolute left-[6%] top-[14%] hidden h-24 w-24 opacity-20 sm:block"
          style={{
            backgroundImage:
              "radial-gradient(circle, #2563EB 2px, transparent 2px)",
            backgroundSize: "16px 16px",
          }}
        />
      </div>

      {/* =====================================================
        PAGE
    ====================================================== */}
      <div className="relative z-10 flex min-h-screen flex-col">
        {/* ===================================================
          HEADER
      ==================================================== */}
        <header className="border-b border-white/40 bg-white/30 backdrop-blur-md">
          <div className="mx-auto flex h-16 w-full max-w-7xl items-center px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3">
              {/* Logo */}
              <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-xl border border-white/60 bg-blue-500 p-1 shadow-sm">
                <img
                  src="/images/chiksoft.png"
                  alt="ChikSoft"
                  className="h-full w-full object-contain"
                />
              </div>

              <div>
                <h1 className="text-[15px] font-bold leading-none tracking-tight text-[#17233E]">
                  ChikSoft
                </h1>

                <p className="mt-1 text-[8px] font-medium text-slate-500">
                  Gestion scolaire moderne
                </p>
              </div>
            </div>
          </div>
        </header>

        {/* ===================================================
          MAIN
      ==================================================== */}
        <main className="flex flex-1 items-center justify-center px-4 py-8 sm:px-6">
          <div className="w-full max-w-[470px]">
            {/* =================================================
              ERROR CARD
          ================================================== */}
            <div className="overflow-hidden rounded-2xl border border-white/70 bg-white/75 shadow-[0_18px_55px_rgba(50,70,110,0.12)] backdrop-blur-xl">
              <div className="px-6 py-7 text-center sm:px-8">
                {/* =============================================
                  NETWORK ILLUSTRATION
              ============================================== */}
                <div className="relative mx-auto mb-5 flex h-[105px] w-[150px] items-center justify-center">
                  {/* Subtle circle */}
                  <div className="absolute h-[92px] w-[92px] rounded-full bg-blue-500/[0.06]" />

                  <div className="absolute h-[68px] w-[68px] rounded-full bg-blue-500/[0.07]" />

                  {/* WiFi */}
                  <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl border border-blue-100 bg-white text-blue-500 shadow-sm">
                    <i className="fas fa-wifi text-xl" />

                    {/* Error badge */}
                    <div className="absolute -bottom-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full border-[3px] border-white bg-red-500 text-white shadow-sm">
                      <i className="fas fa-exclamation text-[7px]" />
                    </div>
                  </div>

                  {/* Connection line left */}
                  <div className="absolute left-0 top-1/2 flex items-center">
                    <div className="h-px w-6 border-t border-dashed border-slate-300" />

                    <div className="flex h-6 w-6 items-center justify-center rounded-lg bg-white/70 text-slate-400 shadow-sm">
                      <i className="fas fa-laptop text-[8px]" />
                    </div>
                  </div>

                  {/* Server right */}
                  <div className="absolute right-0 top-1/2 flex items-center">
                    <div className="flex h-6 w-6 items-center justify-center rounded-lg bg-white/70 text-slate-400 shadow-sm">
                      <i className="fas fa-server text-[8px]" />
                    </div>

                    <div className="h-px w-6 border-t border-dashed border-slate-300" />
                  </div>
                </div>

                {/* =============================================
                  ERROR MESSAGE
              ============================================== */}
                <div>
                  <div className="mb-2 flex items-center justify-center gap-2">
                    <span className="rounded-full bg-red-50 px-2.5 py-1 text-[8px] font-semibold uppercase tracking-wider text-red-500">
                      Connexion interrompue
                    </span>
                  </div>

                  <h2 className="text-[19px] font-semibold tracking-tight text-[#17233E] sm:text-[21px]">
                    Oops! Erreur de connexion
                  </h2>

                  <p className="mx-auto mt-2.5 max-w-[360px] text-[10px] leading-[1.7] text-slate-500 sm:text-[11px]">
                    Nous rencontrons des difficultés pour nous connecter à nos
                    serveurs. Veuillez vérifier votre connexion Internet et
                    réessayer dans un instant.
                  </p>
                </div>

                {/* =============================================
                  CONNECTION SUGGESTION
              ============================================== */}
                <div className="mx-auto mt-5 flex max-w-[350px] items-start gap-3 rounded-xl border border-slate-200/70 bg-slate-50/70 p-3 text-left">
                  <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-500">
                    <i className="fas fa-circle-info text-[9px]" />
                  </div>

                  <div>
                    <p className="text-[9px] font-semibold text-slate-600">
                      Vérifiez votre connexion
                    </p>

                    <p className="mt-0.5 text-[8px] leading-relaxed text-slate-400">
                      Assurez-vous que votre appareil est connecté à Internet
                      avant de réessayer.
                    </p>
                  </div>
                </div>

                {/* =============================================
                  RETRY
              ============================================== */}
                <div className="mt-5">
                  <button
                    onClick={handleRetry}
                    disabled={isRetrying}
                    className={`group flex h-10 w-full items-center justify-center gap-2 rounded-lg px-4 text-[10px] font-semibold text-white shadow-[0_5px_15px_rgba(37,99,235,0.18)] transition ${
                      isRetrying
                        ? "cursor-not-allowed bg-blue-400"
                        : "bg-blue-600 hover:bg-blue-700 active:scale-[0.99]"
                    }`}
                  >
                    {isRetrying ? (
                      <>
                        <i className="fas fa-spinner fa-spin text-[9px]" />
                        <span>Chargement...</span>
                      </>
                    ) : (
                      <>
                        <i className="fas fa-rotate-right text-[9px] transition-transform duration-300 group-hover:rotate-45" />
                        <span>Réessayer</span>
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* ===============================================
                CARD FOOTER
            ================================================ */}
            </div>

            {/* =================================================
              COPYRIGHT
          ================================================== */}
            <div className="mt-4 text-center">
              <p className="text-[8px] text-slate-500">
                ©{new Date().getFullYear()} Ehula Technologies. Tous droits
                réservés.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ConnexionErrorPage;
